const STRIPE_SCRIPT_MATCH = 'js.stripe.com/v3';
const ONETRUST_CONSENT_EVENTS = ['OneTrustGroupsUpdated', 'OptanonOnConsentChanged'];

function normalizeStripeSrc(URL) {
	if (URL.indexOf('http') === 0) {
		return URL;
	}
	const path = URL.replace(/^\/\//, '');
	return `https://${path}`;
}

function findExistingStripeScript() {
	return Array.from(document.querySelectorAll('script')).find(
		(script) => script.src && script.src.includes(STRIPE_SCRIPT_MATCH)
	);
}

function isScriptBlockedByOneTrust(script) {
	return script && script.type === 'text/plain';
}

function onStripeLoadError() {
	console.error(
		'[Stripe] No se pudo cargar el script. Si usas OneTrust, acepta las cookies necesarias o configura js.stripe.com como script permitido.'
	);
}

function createStripeScript(src) {
	const script = document.createElement('script');
	script.src = src;
	script.type = 'text/javascript';
	// Necesario para pagos: evita que OtAutoBlock bloquee Stripe en el flujo de donación
	script.setAttribute('data-ot-ignore', '');
	return script;
}

function waitForOneTrustConsent(src, onReady) {
	let done = false;
	const finish = () => {
		if (done || !window.Stripe) {
			return;
		}
		done = true;
		onReady();
	};

	const onConsent = () => {
		if (window.Stripe) {
			finish();
			return;
		}
		const blocked = findExistingStripeScript();
		if (blocked && isScriptBlockedByOneTrust(blocked)) {
			blocked.parentNode.removeChild(blocked);
		}
		appendStripeScript(src, finish, onStripeLoadError);
	};

	ONETRUST_CONSENT_EVENTS.forEach((eventName) => {
		window.addEventListener(eventName, onConsent, false);
	});
	window.addEventListener('onetrust-consent-ready', onConsent, false);
}

function appendStripeScript(src, onLoad, onError) {
	const script = createStripeScript(src);
	script.addEventListener('load', onLoad, false);
	script.addEventListener('error', onError || onStripeLoadError, false);
	document.head.appendChild(script);
	return script;
}

function loadStripeScript(src, callback) {
	const run = () => {
		if (typeof callback === 'function') {
			callback();
		}
	};

	if (window.Stripe) {
		run();
		return;
	}

	const existing = findExistingStripeScript();
	if (existing) {
		if (window.Stripe) {
			run();
			return;
		}
		if (isScriptBlockedByOneTrust(existing)) {
			waitForOneTrustConsent(src, run);
			return;
		}
		if (existing.readyState === 'complete' || existing.readyState === 'loaded') {
			setTimeout(() => (window.Stripe ? run() : onStripeLoadError()), 0);
			return;
		}
		existing.addEventListener('load', run, false);
		existing.addEventListener('error', onStripeLoadError, false);
		return;
	}

	appendStripeScript(src, run, onStripeLoadError);

	setTimeout(() => {
		if (window.Stripe) {
			return;
		}
		const inserted = findExistingStripeScript();
		if (inserted && isScriptBlockedByOneTrust(inserted)) {
			waitForOneTrustConsent(src, run);
		}
	}, 0);
}

/**
 * Carga Stripe.js una sola vez y ejecuta callback cuando window.Stripe está disponible.
 * Compatible con OneTrust OtAutoBlock (data-ot-ignore + reintento tras consentimiento).
 * @param {string} URL - p. ej. 'js.stripe.com/v3/'
 * @param {Function} callback
 */
export default function includeStripe(URL, callback) {
	loadStripeScript(normalizeStripeSrc(URL), callback);
}



// WEBPACK FOOTER //
// ./src/utils/includeStripe.js